import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth, useBrowserQuery } from '@/hooks/common'
import { AxiosProvider } from '@/context/Axios'
import { HOME_PATH } from '@/utils/constants'
import AuthDialog from '../../auth/AuthDialog'
import { LandingV2Page } from './LandingV2Page'

/**
 * Home route (`/`) wrapper for Landing v2 — carries the same auth-redirect
 * and `/auth?step=` dialog wiring the legacy GuestLandingLayout owned, so
 * signed-in visitors still skip straight to their workspace and the
 * login/signup/forgot-password modal still opens over the marketing page.
 */
export default function LandingV2Layout() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const query = useBrowserQuery()
  const authStep = query.get('step') || ''
  const showAuthDialog = location.pathname === '/auth' && authStep.length > 0

  useEffect(() => {
    if (user?.userID) {
      const redirectPath = query.get('redirect')
      navigate(redirectPath || HOME_PATH)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userID])

  return (
    <AxiosProvider>
      <LandingV2Page />
      <AuthDialog authStep={authStep} open={showAuthDialog} onClose={() => navigate('/')} />
    </AxiosProvider>
  )
}
